import { render } from "./AdminBusinessHours.vue?vue&type=template&id=553e0681&scoped=true"
import script from "./AdminBusinessHours.vue?vue&type=script&lang=js"
export * from "./AdminBusinessHours.vue?vue&type=script&lang=js"

import "./AdminBusinessHours.vue?vue&type=style&index=0&id=553e0681&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553e0681"]])

export default __exports__